import { getField, updateField } from "vuex-map-fields";

function genID() {
  var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  var ID_LENGTH = 8;

  var generate = function() {
    var rtn = "";
    for (var i = 0; i < ID_LENGTH; i++) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return rtn;
  };
  return generate();
}

export default {
  namespaced: true,
  state: {
    selectedPlan: 0,
    formValid: true,
    dataModel: [
      {
        pid: genID(),
        relationship: "self",
        gender: "",
        dob: "",
        name: "",
        fname: "",
        lname: "",
        death: '',
        notes: "",
        conditions: [],
      },
      {
        pid: genID(),
        relationship: "mother",
        name: "mother",
        gender: "Female",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      },
      {
        pid: genID(),
        relationship: "father",
        name: "father",
        gender: "Male",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      },
      {
        pid: genID(),
        relationship: "maternal grandfather",
        name: "maternal grandfather",
        gender: "Male",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      },
      {
        pid: genID(),
        relationship: "maternal grandmother",
        name: "maternal grandmother",
        gender: "Female",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      },
      {
        pid: genID(),
        relationship: "paternal grandfather",
        name: "paternal grandfather",
        gender: "Male",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      },
      {
        pid: genID(),
        relationship: "paternal grandmother",
        name: "paternal grandmother",
        gender: "Female",
        isLiving: true,
        dob: '',
        death: '',
        conditions: [],
        notes: "",
      }
    ],
    snackbar: false,
    genderList: [
      "Male",
      "Female",
      "Other"
    ],
    relations: [
      "grandchild",
      "child",
      "sibling",
      "niece/nephew",
      "maternal aunt",
      "maternal uncle",
      "maternal cousin",
      "paternal aunt",
      "paternal uncle",
      "paternal cousin"
    ],
    ancestryQuestion: [
      "American Indian or Alaskan Native",
      "Asian",
        "South Asian (Indian, Afghan, Pakistani, etc)",
        "North Asian (Siberian, Mongolian, etc)",
        "Southeast Asian (Vietnamese, Thai, etc)",
        "East Asian (Chinese, Japanese, Korean, etc)",
      "Black (African, African American, West Indies)",
      "Hispanic/Latino (Mexican, Puerto Rican, Cuban, etc)",
      "Middle Eastern (Iranian, Syrian, Turkish, etc)",
      "North African (Egyptian, Lebanese, Algerian, etc)",
      "Native Hawaiian/Pacific Islander (Samoan, Guamanian, etc)",
      "White",
        "Northwest European (British, Irish, Welsh, Scottish)",
        "Western European (French, German, Belgian, etc)",
        "Scandinavian (Swedish, Norwegian, Danish)",
        "Finnish",
        "Southern Europe (Spanish, Portuguese, Italian, etc)",
        "Eastern Europe (Ukrainian, Polish, Romanian, etc)",
      "Unknown"
    ],
    femaleQuestions: [
      {
        question: "How old were you at menarche (when you first got your period)?",
        type: "int"
      },
      {
        question: "How many years have you taken birth control pills?",
        type: "int"
      },
      {
        question: "How many times have you been pregnant (including miscarriages and pregnancy terminations)?",
        type: "int"
      },
      {
        question: "If you have had children, how old were you when you had your first child?.",
        type: "int"
      },
      {
        question: "If you have had children, did you ever breastfeed?",
        type: "yn"
      },
      {
        question: "Do you examine your breasts every month for suspicious lumps or changes?",
        type: "yn"
      },
      {
        question: "Have you had mammogram screening before?",
        type: "yn"
      },
      {
        question: "If yes, how old were you when you got your first mammogram?",
        type: "int"
      },
      {
        question: "When was your most recent mammogram?",
        type: "str"
      },
      {
        question: "How many breast biopsies have you had?",
        type: "int"
      },
      {
        question: "Have you ever had an abnormal breast biopsy result?",
        type: "yn"
      },
      {
        question: "Have you had a mastectomy (surgical removal of one or both breasts)?",
        type: "yn"
      },
      {
        question: "Have you had a hysterectomy (removal of the uterus)?",
        type: "yn"
      },
      {
        question: "Have you had an oophorectomy (removal of the ovaries)?",
        type: "yn"
      },
      {
        question: "Have you had a salpingectomy (removal of the Fallopian tubes)?",
        type: "yn"
      },
      {
        question: "Have you ever taken hormone replacement therapy?",
        type: "yn"
      },
      {
        question: "If you have gone through menopause, at what age did your periods stop?",
        type: "int"
      },
    ],
    condictions: [
      {
        bucket: "Auto-immune/Rheumatic Disorders",
        list: [
          "Ankylosing Spondylitis",
          "Celiac disease",
          "Dermatomyositis",
          "Fibromyalgia",
          "Gout",
          "Inflammatory Myositis",
          "Lupus (Systemic Lupus Erythematous)",
          "Osteoarthritis",
          "Osteoporosis",
          "Polymyalgia Rheumatica",
          "Psoriatic Arthritis",
          "Rheumatoid Arthritis",
          "Sarcoidosis",
          "Scleroderma",
          "Sjogren’s Syndrome",
          "Vasculitis",
        ]
      },
      {
        bucket: "Cancer",
        list: [
          "Breast",
          "Ovarian",
          "Uterine",
          "Cervical",
          "Bladder",
          "Prostate",
          "Kidney",
          "Testicular",
          "Colorectal",
          "Gastric/Stomach",
          "Anal",
          "Esophageal",
          "Fallopian Tube",
          "Gastroesophageal junction",
          "Gallbladder",
          "Liver",
          "Pancreatic",
          "Primary Peritoneal",
          "Lung",
          "Skin",
          "Melanoma",
          "Leukemia",
          "Lymphoma",
          "Brain",
          "Bone",
          "Mesothelioma",
        ]
      },
      {
        bucket: "Cardiovascular",
        list: [
          "Angina",
          "Cardiomyopathy (hypertrophic or dilated)",
          "Coronary artery disease",
          "Deep vein thrombosis (blood clot) or pulmonary embolism (blood clot in the lung)",
          "Heart arrhythmia",
          "Heart attack",
          "Heart disease",
          "High cholesterol",
          "Hypertension or high blood pressure",
          "Stroke",
          "Sudden unexplained death",
        ]
      },
      {
        bucket: "Connective Tissue/Skeletal",
        list: [
          "Ehlers Danlos Syndrome",
          "Loeys-Dietz syndrome",
          "Marfan Syndrome",
          "Osteogenesis Imperfecta",
          "Unexplained frequent or easy bone fractures",
          "Osteoporosis",
          "Significantly taller or significantly shorter than other members of the family",
          "Back pain",
        ]
      },
      {
        bucket: "Developmental/Cognitive",
        list: [
          "Intellectual disability/cognitive impairment",
          "Developmental delay (walking or talking later than expected, not meeting developmental milestones at typical ages, etc.)",
          "Learning disabilities (dyslexia, needing extra help in school, etc)",
          "Attention Deficit/Hyperactivity Disorder (ADHD)",
          "Autism spectrum disorder",
        ]
      },
      {
        bucket: "Endocrine",
        list: [
          "Type 1 Diabetes",
          "Type 2 Diabetes",
          "Osteoporosis",
          "Thyroid Cancer",
          "Addison's Disease",
          "Cushing's Syndrome",
          "Graves' Disease",
          "Hashimoto's Thyroiditis",
          "Hypothyroidism",
          "Hyperthyroidism",
          "Polycystic Ovarian Syndrome (PCOS)",
        ]
      },
      {
        bucket: "Genetic Conditions",
        list: [
          "Cystic fibrosis",
          "Sickle cell anemia",
          "Thalassemia",
          "Tay-Sachs disease",
          "Spinal muscular atrophy",
          "Muscular Dystrophy (Specify Type)",
          "Fragile X syndrome",
          "Chromosome condition (Specify Type)",
        ]
      },
      {
        bucket: "Gastrointestinal",
        list: [
          "Colitis",
          "Colon polyps",
          "Crohn's disease",
          "Diverticular disease",
          "Inflammatory bowel disease",
          "Irritable bowel syndrome (IBS)",
        ]
      },
      {
        bucket: "Genitourinary System",
        list: [
          "Hypospadias",
          "Prostatitis",
          "Prostate cancer",
          "Testicular torsion",
          "Undescended testes or cryptorchidism",
        ]
      },
      {
        bucket: "Gynecological",
        list: [
          "Three or more miscarriages",
          "Stillbirth",
          "Delayed puberty/sexual maturation",
          "Infertility",
          "Endometriosis",
        ]
      },
      {
        bucket: "Mental Health",
        list: [
          "Addiction",
          "Attention Deficit/Hyperactivity Disorder (ADHD)",
          "Anxiety",
          "Bipolar disorder",
          "Depression",
          "Eating disorder (bulimia/anorexia)",
          "Obsessive compulsive disorder",
          "Panic disorder",
          "Personality disorder",
          "Post-traumatic stress disorder",
          "Schizophrenia",
          "Social phobia",
        ]
      },
      {
        bucket: "Neurological",
        list: [
          "Amyotrophic lateral sclerosis (ALS)",
          "Alzheimer’s disease",
          "Aneurysm",
          "Ataxia",
          "Fragile X-related Ataxia",
          "Bell’s palsy",
          "Birth defects of the brain and spinal cord",
          "Brain injury",
          "Brain tumor",
          "Cerebral palsy",
          "Chronic fatigue syndrome",
          "Concussion",
          "Dementia",
          "Disk disease of neck and lower back",
          "Dizziness",
          "Epilepsy",
          "Guillain-Barré syndrome",
          "Headaches and migraines",
          "Multiple sclerosis",
          "Muscular dystrophy",
          "Neuralgia",
          "Neuropathy",
          "Neuromuscular and related diseases",
          "Parkinson’s disease",
          "Psychiatric conditions (severe depression, obsessive-compulsive disorder)",
          "Scoliosis",
          "Seizures",
          "Spinal cord injury",
          "Spinal deformity and disorders",
          "Spine tumor",
          "Stroke",
          "Vertigo",
        ]
      },
      {
        bucket: "Pulmonary/Respiratory",
        list: [
          "Asbestosis",
          "Asthma",
          "Bronchiectasis",
          "Bronchitis",
          "Chronic Cough",
          "Chronic Obstructive Pulmonary Disease (COPD)",
          "Cystic Fibrosis",
          "Idiopathic Pulmonary Fibrosis",
          "Lung Cancer",
          "Pleurisy",
          "Pneumonia",
          "Pulmonary Embolism",
          "Pulmonary Hypertension",
          "Sarcoidosis",
          "Sleep Apnea",
          "Sudden Infant Death Syndrome (SIDS)",
          "Tuberculosis",
        ]
      },
      {
        bucket: "Renal/Kidney",
        list: [
          "Glomerulonephritis",
          "Hemolytic uremic syndrome",
          "Hydronephrosis",
          "Polycystic kidney disease",
          "Urinary tract infections",
        ]
      },
      {
        bucket: "Vision",
        list: [
          "Myopia (near-sighted)",
          "Hyperopia (far-sighted)",
          "Macular degeneration",
          "Glaucoma",
          "Cataracts",
          "Dislocated lens of the eye (ectopia lentis)",
        ]
      },
      {
        bucket: "Hearing",
        list: [
          "Conductive hearing loss",
          "Sensorineural hearing loss",
        ]
      },
    ],
    conditionList: [
      "Heart defect",
      "Cleft lip/cleft palate",
      "Club feet",
      "Neural tube defect (spina bifida)",
      "Abdominal wall defect",
      "Intellectual delays/cognitive impairment",
      "Developmental delay",
      "Learning disabilities",
      "Attention Deficit/Hyperactivity Disorder (ADHD)",
      "Autism spectrum disorder",
      "Kidney Cancer",
      "Breast Cancer",
      "Bladder Cancer",
      "Colorectal Cancer",
      "Gastric/Stomach Cancer",
      "Anal Cancer",
      "Esophageal Cancer",
      "Gastroesophageal junction Cancer",
      "Gallbladder Cancer",
      "Liver Cancer",
      "Pancreatic Cancer",
      "Lung Cancer",
      "Skin Cancer",
      "Melanoma",
      "Leukemia",
      "Lymphoma",
      "Brain Cancer",
      "Bone Cancer",
      "Mesothelioma",
      "Angina",
      "Cardiomyopathy",
      "Coronary artery disease",
      "Deep vein thrombosis (Blood Clot)",
      "pulmonary embolism (Blood Clot in the Lung)",
      "Heart arrhythmia",
      "Heart attack",
      "Heart disease",
      "High cholesterol",
      "Hypertension or high blood pressure",
      "Stroke",
      "Sudden unexplained death",
      "Addiction",
      "Anxiety",
      "Bipolar disorder",
      "Depression",
      "Eating disorder",
      "Obsessive compulsive disorder",
      "Panic disorder",
      "Personality disorder",
      "Post-traumatic stress disorder",
      "Schizophrenia",
      "Amyotrophic lateral sclerosis (ALS)",
      "Alzheimer’s disease",
      "Aneurysm",
      "Back pain",
      "Bell’s palsy",
      "Birth defects of the brain and spinal cord",
      "Brain injury",
      "Brain tumor",
      "Cerebral palsy",
      "Chronic fatigue syndrome",
      "Concussion",
      "Dementia",
      "Disk disease of neck and lower back",
      "Dizziness",
      "Epilepsy",
      "Guillain-Barré syndrome",
      "Headaches and migraines",
      "Multiple sclerosis",
      "Muscular dystrophy",
      "Neuralgia",
      "Neuropathy",
      "Neuromuscular and related diseases",
      "Parkinson’s disease",
      "Psychiatric conditions (severe depression, obsessive-compulsive disorder)",
      "Scoliosis",
      "Seizures",
      "Spinal cord injury",
      "Spinal deformity and disorders",
      "Spine tumor",
      "Stroke",
      "Vertigo",
      "Myopia (near-sighted)",
      "Hyperopia (far-sighted)",
      "Macular degeneration",
      "Glaucoma",
      "Cataracts",
      "Dislocated lens of the eye (ectopia lentis)",
      "Conductive hearing loss",
      "Sensorineural hearing loss",
      "Type 1 Diabetes",
      "Type 2 Diabetes",
      "Osteoporosis",
      "Thyroid Cancer",
      "Addison's Disease",
      "Cushing's Syndrome",
      "Graves' Disease",
      "Hashimoto's Thyroiditis",
      "Colitis",
      "Colon polyps",
      "Crohn's disease",
      "Diverticular disease",
      "Inflammatory bowel disease",
      "Irritable bowel syndrome (IBS)",
      "Glomerulonephritis",
      "Hemolytic uremic syndrome",
      "Hydronephrosis",
      "Polycystic kidney disease",
      "Urinary tract infections",
      "Asbestosis",
      "Asthma",
      "Bronchiectasis",
      "Bronchitis",
      "Chronic Cough",
      "Chronic Obstructive Pulmonary Disease (COPD)",
      "Cystic Fibrosis",
      "Idiopathic Pulmonary Fibrosis",
      "Pleurisy",
      "Pneumonia",
      "Pulmonary Embolism",
      "Pulmonary Hypertension",
      "Sarcoidosis",
      "Sleep Apnea",
      "Sudden Infant Death Syndrome (SIDS)",
      "Tuberculosis",
      "Ankylosing Spondylitis",
      "Dermatomyositis",
      "Fibromyalgia",
      "Gout",
      "Inflammatory Myositis",
      "Lupus (Systemic Lupus Erythematous)",
      "Osteoarthritis",
      "Osteoporosis",
      "Polymyalgia Rheumatica",
      "Psoriatic Arthritis",
      "Rheumatoid Arthritis",
      "Sarcoidosis",
      "Scleroderma",
      "Sjogren’s Syndrome",
      "Vasculitis",
      "Ehlers Danlos Syndrome",
      "Loeys-Dietz syndrome",
      "Marfan Syndrome",
      "Osteogenesis Imperfecta",
      "Unexplained frequent or easy bone fractures",
      "Osteoporosis",
      "Significantly taller or significantly shorter than other members of the family",
      "Cystic fibrosis",
      "Sickle cell anemia",
      "Thalassemia",
      "Tay-Sachs disease",
      "Spinal muscular atrophy",
      "Muscular Dystrophy",
      "Fragile X syndrome",
      "Chromosome condition",
      "Hyperthyroid",
      "hypothyroid",
      "joint pain",
      "chronic pain",
      "hypermobility",
      "DCIS",
      "autoimmune condition (not further defined)",
      // Female only
      "Endometriosis",
      "Fibroids",
      "Premature menopause",
      "Ovarian cysts",
      "Ovarian Cancer",
      "Uterine Cancer",
      "Cervical Cancer",
      "Fallopian Tube Cancer",
      "Primary Peritoneal Cancer",
      // Male only
      "Hypospadias",
      "Prostatitis",
      "Prostate cancer",
      "Testicular torsion",
      "Undescended testes or cryptorchidism",
      "Prostate Cancer",
      "Testicular Cancer",
    ],
    exposureList: [
      "Cigarettes",
      "Pipe Tabacco",
      "Cigars",
      "E-Cigarettes",
      "Snuff",
      "Chew Tabacco",
      "Alcohol",
      "Cocaine",
      "Marijuana",
      "Methamphetamines",
      "Anti-anxiety Meds",
      "Amphetamines",
      "Barbituates",
      "Heroin",
      "Inhalants",
      "LSD",
      "Narcotics",
      "Nitrous Oxide",
      "PCP",
      "IV",
    ],
    errorText: null
  },

  getters: {
    getField
  },
  mutations: {
    updateField
  },
  actions: {}
};
